
import Tabla from "@/components/servicios/TablaServiciosProgramados.vue";
import { useAdminComarca } from "@/composable/useAdminComarca";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import Page from "@/layout/Page.vue";
import { Municipio } from "@/store/models";
import {
  AuthModule,
  MunicipiosModule,
  ServiciosProgramadosModule,
} from "@/store/modules";
import Swal from "sweetalert2/dist/sweetalert2.js";
import {
  computed,
  defineComponent,
  onActivated,
  onMounted,
  ref,
  watch,
} from "vue";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { getModule } from "vuex-module-decorators";

export default defineComponent({
  name: "servicios-programados-listado",
  components: { Page, Tabla },
  setup() {
    const { t } = useI18n();
    const store = useStore();
    const router = useRouter();
    const module = getModule(ServiciosProgramadosModule, store);
    const authModule = getModule(AuthModule, store);
    const municipiosModule = getModule(MunicipiosModule, store);

    const authComarcaId = authModule.user.comarcaId;
    const { selectedComarcaId } = useAdminComarca();

    const error = computed(() => module.errors);

    watch(error, () => {
      if (!error.value) return;

      Swal.fire({
        text:
          t("errors." + (error.value.error.code ?? error.value.error.name)) ??
          error.value.error.name,
        icon: "error",
        buttonsStyling: false,
        confirmButtonText: t("dialogs.okButton"),
        customClass: {
          confirmButton: "btn btn-primary",
        },
      });
    });
    const cargaListado = ref(false);

    const municipios = ref<Municipio[]>([]);
    const loadMunicipios = async () => {
      if (municipios.value.length === 0) {
        await municipiosModule.fetch();
        municipios.value = municipiosModule.municipios;
      }
    };

    const reloadListado = async () => {
      const isAdmin = !authComarcaId;

      if (isAdmin && !selectedComarcaId.value) {
        module.setData([]);
        return;
      }

      let idToFetch: string | undefined;
      if (isAdmin) {
        idToFetch =
          selectedComarcaId.value === "TODAS"
            ? undefined
            : selectedComarcaId.value!;
      } else {
        idToFetch = authComarcaId;
      }

      await module.fetchListado(idToFetch);
    };

    onActivated(async () => {
      if (cargaListado.value) return;

      cargaListado.value = true;
      try {
        await loadMunicipios();
        await reloadListado();
      } catch (err) {
        Swal.fire({
          text: t("formularios.serviciosProgramadosListado.cargar.error"),
          icon: "error",
          buttonsStyling: false,
          confirmButtonText: t("dialogs.okButton"),
          customClass: {
            confirmButton: "btn btn-primary",
          },
        });
      } finally {
        cargaListado.value = false;
      }
    });

    onMounted(() => {
      setCurrentPageBreadcrumbs(t("menu.serviciosProgramados"), [
        t("menu.servicios"),
      ]);
    });

    return {
      servicios: computed(() => module.servicios),
      cargaListado,
      crearNuevo: () => {
        router.push("/listados/servicios-programados/nuevo");
      },
      municipios,
      reloadListado,
    };
  },
});
